<template>
  <a-row class="controls" type="flex" justify="space-between">
    <a-col>
      <a-form layout="inline" :model="formState">
        <a-form-item>
          <a-input
            v-model:value="formState.search"
            placeholder="Buscar por nombre de referido"
            class="form__input"
            @change="emit('update')"
          >
            <template #prefix>
              <SearchOutlined />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-select
            v-model:value="formState.state"
            placeholder="Estado"
            class="form__select"
            @change="emit('update')"
          >
            <a-select-option :key="0"> Todos los estados </a-select-option>
            <a-select-option v-for="state in stateOptions" :key="state.id">
              {{ state.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-col>
    <a-col>
      <a-button
        @click="emit('openBenefitsModal')"
      >
        Ver beneficios
        <GiftOutlined />
      </a-button>
      <a-divider type="vertical" />
      <a-button
        type="primary"
        id="add-new-referral"
        @click="emit('openRegisterNewBenefit')"
      >
        Añadir nuevo referido
      </a-button>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
import { inject, ref } from 'vue';
import { ReferredStatus, ReferredStatusText } from '../../utils/enums';
import { GiftOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { Ref } from 'vue';

const emit = defineEmits(['update', 'openBenefitsModal', 'openRegisterNewBenefit']);

const formState = inject<Ref<any>>("formFilter");

const stateOptions = ref([
  { 
    id: ReferredStatus.Pending,
    name: ReferredStatusText[ReferredStatus.Pending]
  },
  {
    id: ReferredStatus.Earned,
    name: ReferredStatusText[ReferredStatus.Earned]
  },
  {
    id: ReferredStatus.Lost,
    name: ReferredStatusText[ReferredStatus.Lost]
  },
]);


</script>

<style scoped lang="sass">
.form__input
  width: 300px
</style>
